class GlobalStore {
  private static instance: GlobalStore | null = null;
  private _eventSubdomain: string | null = '';

  public static getInstance(): GlobalStore {
    if (this.instance === null) {
      this.instance = new GlobalStore();
    }
    return this.instance;
  }

  get eventSubdomain(): string | null {
    return this._eventSubdomain;
  }

  set eventSubdomain(value: string) {
    this._eventSubdomain = value;
  }
}

export default GlobalStore;